// cardScanApi — Tarjeta QR del cliente + escáner en el celular del empleado (23-oct-2026, «sin tablet»).
// El cliente trae SU QR (código opaco, nunca el teléfono) y el empleado lo lee con la cámara de su
// celular desde el manager: la visita se registra al instante (source='scan'), sin bandeja de aprobación.
// Backend: lealify-base routes/loyalty.js (/contacts/by-code, /contacts/:id/card, /card-scan/resumen).
import { baseApi } from './baseClient';

export interface CardContact {
  id: number;
  first_name: string;
  last_name: string | null;
  phone: string;
  email: string | null;
  points_balance: string | number;
  last_visit_at: string | null;
  card_code: string;
  tags: string[];
}

export interface CardScanResumen {
  enabled: boolean;
  hoy: number;            // visitas escaneadas hoy
  mes: number;            // visitas escaneadas en 30 días
  clientes_mes: number;   // clientes distintos escaneados en 30 días
  con_tarjeta: number;    // clientes que ya tienen tarjeta generada
  total: number;          // clientes activos
}

// Lo que leyó la cámara puede ser el código pelón o la URL completa de la tarjeta
// (https://app.lealify.com/c/<slug>/<code>). Mismo criterio que el backend (lib/loyalty.js parseCardCode).
export function parseCardCode(raw: string): string | null {
  const s = String(raw || '').trim();
  if (!s) return null;
  const m = s.match(/\/c\/[^/]+\/([A-Za-z0-9]{6,12})\b/);
  const code = (m ? m[1] : s).toUpperCase();
  return /^[A-Z2-9]{6,12}$/.test(code) ? code : null;
}

export const cardScanApi = {
  byCode: (code: string) =>
    baseApi.get<{ contact: CardContact }>(`/loyalty/contacts/by-code/${encodeURIComponent(code)}`),

  // Da (o recupera) la tarjeta de un cliente para mostrársela, imprimirla o mandársela por WhatsApp.
  card: (contactId: number | string) =>
    baseApi.post<{ code: string; url: string }>(`/loyalty/contacts/${encodeURIComponent(String(contactId))}/card`, {}),

  resumen: () => baseApi.get<CardScanResumen>('/loyalty/card-scan/resumen'),

  setEnabled: (on: boolean) => baseApi.put('/loyalty/settings', { card_scan_enabled: on ? 1 : 0 }),
};
